import styled from "styled-components";

interface MainBannerProps {
  bannerSrc: string;
  title?: string;
}

export function MainBanner({ bannerSrc, title }: MainBannerProps) {
  return (
    <Content>
      <Banner src={bannerSrc} />
      {title && <Title>{title}</Title>}
    </Content>
  );
}
const Content = styled.div`
  position: relative;
  overflow: hidden;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    height: 180px;
  }
`;

const Banner = styled.img`
  display: block;
  width: 100%;
  height: auto;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    height: 100%;
    width: auto;
    overflow: hidden;
  }
`;

const Title = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 68px;
  color: #fff;
  text-shadow: 0 4px 12px rgba(0, 0, 40, 0.6);

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 48px;
  }
`;